import React, { Component } from 'react';
import { connect } from 'react-redux';
import { 
	ThemeProvider, 
	FixedWrapper,
	defaultTheme 
} from '@livechat/ui-kit';
import { message } from 'antd';
import axios from 'axios';
import uuid from 'react-uuid';
import {decode} from 'html-entities';
import moment from "moment";
import Maximized from './components/Maximized';
import Minimized from './components/Minimized';
import { getEvents } from './redux/reducers/events';
import { getUsers, getOwnId, getCurrentAgent } from './redux/reducers/users';
import { getRate, getChatState, getToken, getAgentStatus, getConfig } from './redux/reducers/app';
import { 
	sendMessage, 
	rateGood, 
	rateBad, 
	receiveMessage, 
	chatStarted, 
	chatEnded, 
	newUser, 
	setSid, 
	setActivityID,
	setToken, 
	setUUID, 
	onAgentStartTyping,
	onAgentStopTyping,
	setAgentStatus
} from './redux/actions/chatAction';
import { setConfig } from './redux/actions/appAction';
import { 
	connectAgent, 
	connectEce,
	ECE_CONNECT_ERROR,
	initiateToken, 
	initiateUuid, 
	onEceError, 
	onTokenError, 
	onUuidError, 
	receiveToken, 
	receiveUuid, 
	setDispositionEndpoint, 
	showSurvey,
	submitSurvey
} from './redux/actions/dispositionAction';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			spinning: false,
			ignore: true,
      		title: '',
			mobileapp:false,
			refresh:true,
			agentassigned:false,
		};

		/* Create a new instance of the eGainLibrarySettings Object */
		this.librarySettings = new window.eGainLibrarySettings();
		// this.librarySettings.CORSHost = settings.eceurl;
		this.librarySettings.IsDevelopmentModeOn = false;
		this.librarySettings.eGainContextPath = "./";
		/* Next create a new instance of the eGainLibrary */
		/* passing in the settings you have just created. */
		this.myLibrary = new window.eGainLibrary(this.librarySettings);
		this.myChat = new this.myLibrary.Chat();
		this.myEventHandlers = this.myChat.GetEventHandlers();
		this.questiontxt="";
	}

	async componentDidMount() {
		this.mounted = true;

		const settings = await axios.get('/c2c/unauth/settings.json');
		const params=new URLSearchParams(window.location.search).get("type");
		const mobileapp = params?false:true;
		const sid=localStorage.getItem('sid');
		// if type present = web --> mobileapp -->false (coming from web) -- chat minized
		// no type  == mobile --> mobileapp = true -- maximse the chat 
		this.librarySettings.CORSHost = settings.data.eceurl; 
		this.props.setConfig(settings.data);
		this.props.setDispositionEndpoint(settings.data.dispositionEndpoint);

		window.addEventListener('message', (e) => {
			const data = e.data;
			console.log("[ece-chat] Message received  from website", e);
				// error
				if(data.close){
						//check for active chat and close customer side
						if(this.myChat && this.props.currentAgent!=='bot') {
							 this.myChat.End();
						};
				} else if(data.session){
					//check for active chat and close customer side and reload page
					if(this.myChat && this.props.currentAgent!=='bot') {
						 this.myChat.End();
					};
					   // reload page on succsful survey submission
					   window.location.reload(false);
			} 
				else{
					// ingnore messages
				}
		});
		window.addEventListener('beforeunload',(event) =>{
			// clear the tabactive if page is refreshed or window closed.
			console.log("unload tab");
			localStorage.removeItem('tabactive');
			localStorage.removeItem('laststate');
		});
		// this event is triggered for IOS Device 
		window.addEventListener('pagehide',(event) =>{
			// clear the tabactive if page is refreshed or window closed.
			console.log("pagehide tab");
			localStorage.removeItem('tabactive');
			localStorage.removeItem('laststate');
		});
		console.log("[ece-chat] app detect web or mobile type  ",mobileapp);
		/**
		 * Check for Device type 
		 * Mobile app -- auto popup
		 * WEB/Mobile web -- minimise
		 * session exists -- auto pop up 
		 */
		 this.postMessage('chatloaded');
			if(mobileapp) {
			// Detect the device is mobile change header,request token
			this.postMessage('mobile');
			this.initChat();
			} else {
			// Hide the IFrame on chat load
			this.postMessage('minimize');		
			}
			// check for exisiting session and show caht directly
		this.registerEce();
		console.debug('[ece-chat] Is there active session ',sid);
		if(sid){
			this.initChat();
		}
		
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	retriveImageURL= (msg)  =>{
		var findemoji = msg.split('/system');
		if (findemoji.length > 0) {
			var img = findemoji[1].split('"');
			return img[0];
		}
	}

	retriveIMGObj = (msg)  => {
		//var k='<img alt="smiley" height="23" src="/system/web/apps/resources/js/ckeditor/plugins/smiley/images/regular_smile.png" title="smiley" width="23" />';
		let txtobj={};
        var imgsplit = msg.split('/>');
        // actual img string
        txtobj.image = this.retriveImageURL(imgsplit[0]);
        // string after img tag
        var restmsg = imgsplit[1];
        if (restmsg.length > 0) {
            txtobj.type = 'imagebefore'
			let actmsg = restmsg.replace(/<[^>]+>/g, '');
			actmsg = decode(actmsg);
            txtobj.text = actmsg;
        }
    
    return txtobj;
	}
	// read timings form settings .json and check for current time in EST Zone
	checkTod= (tod) =>{
		let open="close";
		const days=['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
		var d = new Date();
		const isDST=moment([d.getFullYear, d.getMonth(), d.getDay()]).isDST();
		var offset=tod.offset;
		if(isDST){
			console.log('Considering daylight saving offset ',tod.dstoffset);
			offset = tod.dstoffset;
		}
		var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
		
		var checknow = new Date(utc + (3600000*offset));
	   console.log('current time in EST ',checknow,checknow.getDay());
	   var whatistoday = days[checknow.getDay()];
	   console.log('what is today ',whatistoday);

		const todaydate=checknow.getFullYear()+'-'+checknow.getMonth()+'-'+checknow.getDate();
		console.log('Is there any timings for today? ',todaydate,tod[todaydate]);
		var timejson=tod.days[whatistoday];
		if(tod[todaydate]){
			timejson=tod[todaydate];
			if(timejson.start){
				timejson=tod[todaydate];
			} else {
				timejson={};
				console.log('Holiday detectd with no hours ');
			}
		}
		console.log('timejson ',timejson);
	   if(timejson && timejson!=={}){
		   const sttime=timejson.start;
		   const ettime=timejson.end;
		//    const sttime=tod.days[whatistoday].start;
		//    const ettime=tod.days[whatistoday].end;
		   console.log('stime ',sttime,'--- enditme',ettime);
		   if(sttime && ettime) {
				// check for openhours
				const hoursopen = new Date(utc + 3600000 * offset);
				const spstart=sttime?.split(":");
				hoursopen.setHours(spstart[0]);
				hoursopen.setMinutes(spstart[1]);
				//set for closed hours
				const hoursclose = new Date(utc + 3600000 * offset);
				const spetime=ettime?.split(":");
				hoursclose.setHours(spetime[0]);
				hoursclose.setMinutes(spetime[1]);
				console.log('current time and date ',checknow);
				console.log('hoursopen ',hoursopen,'--- hoursclose',hoursclose);
				
				const isopen = moment(checknow).isBetween(hoursopen, hoursclose);
				console.log("iscenteropen?",isopen);
				if(isopen){
					open ="open";
				}
		   }
	   }
	   return open;
	
	}
	// this method invokes on chat button click
	initChat = () => {
		// window.parent.postMessage('maximize', '*');
		this.postMessage('maximize');
		const isopen=this.checkTod(this.props.appConfig.tod)
		window.document.body.style.backgroundColor = "#fff"
		if(this.props.token !==  '') return;
		var tabactive=localStorage.getItem("tabactive");
		console.debug("[ece-chat] is chat active in other tabactive ",tabactive,isopen);
		// check if chat is active in other tab
		if(isopen === 'close'){
			var sid = localStorage.getItem("sid");
			var localdata = localStorage.getItem("data");
			console.debug('[ece-chat] check for active session and data', localdata);
			if (sid && localdata) {
				localdata = JSON.parse(localdata);
				this.setState({ spinning: true });
				this.startEce(localdata);

			} else {
				this.props.setAgentStatus({
					status: 'unavailable',
					show: false,
					message: this.props.appConfig.noagentlogin
				});
				this.props.onChatErrored();
				localStorage.setItem('laststate','Agent is not avialable');
			}
		} 
		else if(tabactive){
			this.props.setAgentStatus({
				status: 'unavailable',
				show : false,
				message: 'Oops! A chat session is already in progress. Please continue using your previous chat.'

			});
			this.props.onChatErrored();
			localStorage.setItem('laststate','tab active');
		} 
		else {
			console.debug('[ece-chat] Initiate Chat');
			// this.setState({ spinning: true });
			const genericId = uuid();
			this.props.initiateToken(genericId);
			this.props.setToken("token");
			// make the chat visible
			window.parent.postMessage('maximize', '*');
				var sid=localStorage.getItem("sid");
				var localdata=localStorage.getItem("data");
				console.debug('[ece-chat] check for active session and data',localdata);
				if(sid && localdata){
							localdata=JSON.parse(localdata);
							this.setState({ spinning: true });
							this.startEce(localdata);

				} else {
					this.setState({ spinning: true });
					this.eceWebAPI(this.props.appConfig.agentAvailability, ((res) => {
						console.debug("[ece-chat] agent availability ", res);
						var data = res?.data;
						if (data?.available === false) {
							// TODO
							// show agent not avialable page
							this.props.setAgentStatus({
								status: 'unavailable',
								show: false,
								message: this.props.appConfig.noagentlogin
							});
							this.props.onChatErrored();
							this.setState({ spinning: false });
							localStorage.setItem('laststate','Agent is not Avialable');
						} else {
							//regular flow 
							this.setState({ spinning: false });
						}
					}));
				}
		}
		
	}

	postMessage = (message) => {
		if(message === 'minimize'){
			window.document.body.style.backgroundColor = "#fff0"
			window.parent.postMessage('minimize', '*');
			this.setState({ refresh: false });
		} else if(message === 'maximize'){
			window.document.body.style.backgroundColor = "#fff"
			window.parent.postMessage('maximize', '*');
		} else if(message === 'CustomerInteraction'){
			window.parent.postMessage(message, '*');
		} else if(message === 'sessionid' || message === 'chatloaded'){
			window.parent.postMessage(message, '*');
		}  
		else {
			// do nothing
		}
		if(message === 'close'){
			if(this.myChat && this.props.currentAgent!=='bot') {
				this.myChat.End();
				this.clearSession();
		   } else if(this.myChat) {
			   var localsid=localStorage.getItem('sid');
			   if(localsid){
				this.myChat.End();
				this.clearSession();
			   }
			} 
		   if(this.props.agentStatus) {
			var payload = this.props.agentStatus
			payload.show = false;
			this.props.setAgentStatus(payload);
			}
		}
	}

	// clear session 
	clearSession = () => {
			localStorage.clear();
	}
	onMessageSend = (data) => {
		data = data.replace(/<[^>]+>/g, '');
		this.myChat.SendMessageToAgent(data);
		this.props.onHandleMessageSend(data);
		this.postMessage('CustomerInteraction')
	}

	playSound = (filename) => {
		document.getElementById('sound').muted=false;
		var audio = document.getElementById('sound');
		audio.muted=false;
		audio.play().catch((e) => {
			console.log('[ece-chat] error playing sound ',e);
		  });
	}
	onCustomerTypingChanged = (bool) => {
		// only if aget is assigned sen typing indicator
		if(this.myChat && this.props.currentAgent!=='bot') {
			if(bool) this.myChat.SendCustomerStartTyping();
			else this.myChat.SendCustomerStopTyping();
		};
	}


	alertNotification = (message) => {
		if(this.state.ignore) {
			return;
		}
	
		const now = Date.now();
	
		const title = 'Message from CIBC FCIB Chat';
		const body = message;
		const tag = now;
		// Available options
		// See https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
		const options = {
			tag: tag,
			body: body,
			// icon: icon,
			lang: 'en',
			dir: 'ltr',
			// sound: './assets/notification.mp3'  // no browsers supported https://developer.mozilla.org/en/docs/Web/API/notification/sound#Browser_compatibility
		};

		this.setState({
			title: title,
			options: options
		});
	}

	eceWebAPI = async (url,callback) => {
		const config = {
            headers: {'Content-Type': 'text/xml'},
			method: 'GET',
			//url: 'https://vm-h-ece12-a.dev.in.spinsci.com/system/egain/chat/entrypoint/liveSessionStatus/1001'
			url: url
        };

		try {
            const res = await axios.get(url, config); 
            console.log('[ece-chat] ecewebAPI', url,' and  res: ', res);
			callback(res);
        }catch(error) {
			console.log('[ece-chat] ecewebAPI', url,' and  error: ', error);
			callback({
				data:{
					error:true,
					msg:error
				}
			});
        }
	}

	getUUID = async (token, url, callback) => {
		var data = { session_id: token };

		try {
			this.props.initiateUuid();

			const headers = {
				"Content-Type": "application/json"
			};
            const res = await axios.post(url, data, { headers }); 
            console.log('[ece-chat] getUUID', url,' and  res: ', res);
			callback(res);

			this.props.receiveUuid(res.data?.results[0]?.session_id);
			console.log("[ece-chat] token UUID received ---  ");
        }catch(error) {
            console.log('[ece-chat] getUUID', url,' and  error: ', error.body);
			callback(error);
			if(error && error.toString()){
				this.props.onUuidError(error.toString());
			} else{
				this.props.onUuidError('Error in getting the token');
			}
			
        }
	}

	registerEce = () => {
		try {
			// this.props.onMessageReceive('Please wait while we connect to Live agent');

						// Capture system messages information and agent assignment
			this.myEventHandlers.OnSystemMessageReceived = (systemMessageReceivedEventArgs) => {
				console.log("[ece-chat] OnSystemMessageReceived ", systemMessageReceivedEventArgs);
				if(systemMessageReceivedEventArgs.AgentJoinedMessage) {
					this.setState({ agentassigned: true });
					if(this.props.agentStatus) {
						var payload = this.props.agentStatus
						payload.show = false;
						this.props.setAgentStatus(payload);
					}
					var msg=systemMessageReceivedEventArgs.Message;
					if(msg.includes('You are now chatting with')){
						var agenttext= msg.replace('You are now chatting with ','');
						var name=agenttext?.split(' ');
						if(name && name.length>0){
						this.props.onAgentJoined(name[0]);
						console.log('[ece-chat]clear queue interval');
						clearInterval(this.intervalId);
						this.props.onMessageReceive('You are now chatting with '+name[0]);
						}
						else {
							this.props.onMessageReceive(systemMessageReceivedEventArgs.Message);
						}
						
					} 
				} else {
					if(systemMessageReceivedEventArgs.Message.includes('has ended the chat')) {
						this.props.onMessageReceive(systemMessageReceivedEventArgs.Message);
						if(this.state.agentassigned){
							setTimeout(() => {
								this.props.onChatCompleted(this.props.appConfig.survey.enable);
							}, 2000);
							return;
						} else {
							this.props.onChatCompleted(false);
						}
					}
					else if(systemMessageReceivedEventArgs.Message.includes('You have been transferred to agent')){
						var msg1=systemMessageReceivedEventArgs.Message;
						var agenttext1= msg1.replace('You have been transferred to agent ','');
						var name1=agenttext1?.split(' ');
						if(name1 && name1.length>0){
						// this.props.onAgentJoined(name[0]);
						this.props.onMessageReceive('You have been transferred to agent '+name1[0]);
						}
						else {
							this.props.onMessageReceive(systemMessageReceivedEventArgs.Message);
						}
						
					}  else {
						var textmsg=decode(systemMessageReceivedEventArgs.Message);
						this.props.onMessageReceive(textmsg);
					}
				}
				
			};
		
			this.myEventHandlers.OnAgentStartTyping = (event) => {
				console.debug(
					'[ece-event], agent started typing', event
				);
				this.props.onAgentStartTyping();
			};
		
			this.myEventHandlers.OnAgentStopTyping = (event) => {
				console.debug(
					'[ece-event], agent stopped typing'
				);
				this.props.onAgentStopTyping();
			};

			this.myEventHandlers.OnConnectSuccess = (event) => {
				console.log(
					'[ece-event], OnConnectSuccess', event
				);
				// store the session id used for the survey
				this.props.setSid(event.SessionID);
				// sore the chat activity ID
				localStorage.setItem("activityID",event.ChatID);
				this.props.setActivityID(event.ChatID);
				// event.ChatID
				this.postMessage("sessionid");
				if(this.props.appConfig.refresh) {
					localStorage.setItem("sid",event.SessionID);
					// set the tabactive once chat is connected.
					localStorage.setItem("tabactive",true);
				}
					// once agent is connected send the Question to Agent
				// this.myChat.SendMessageToAgent(this.questiontxt);
				this.props.connectEce();
			};
			
			this.myEventHandlers.OnConnectionFailure = (event) => {
				console.debug('[ece-event], OnConnectionFailure', event);
				
				if(event.StatusCode === 'CONNECT_FAIL') {
					if (event.StatusMessage === "L10N_NO_AGENTS_AVAILABLE") {
						// this.mounted && message.error("No Agents are Available at this time", 5);
						//TODO SHOW Page with No agents available at this time
						this.props.setAgentStatus({
							status: 'unavailable',
							show : false,
							message: 'No agents are available at this time,'

						});
						this.props.onChatErrored();
						localStorage.setItem('laststate',event.StatusMessage );

					} else if (event.StatusMessage === "L10N_SYSTEM_CANNOT_ASSIGN_AGENT") {
						// this.mounted && message.error("Cannot Assign to Agent,please try again", 5);
						//TODO SHOW Page with No agents available at this time
						this.props.setAgentStatus({
							status: 'unavailable',
							show : false,
							message: this.props.appConfig.noagentlogin

						});
						this.props.onChatErrored();
						localStorage.setItem('laststate',event.StatusMessage );

					} 
					else if (event.StatusMessage === "internal-server-error") {
						this.mounted && this.props.setAgentStatus({
							status: 'unavailable',
							show : false,
							message: 'The chat has ended unexpectedly, please refresh page and create a new chat to continue'
						});
						this.props.onChatErrored();
						localStorage.setItem('laststate',event.StatusMessage );

					}else if (event.StatusMessage === "bad-request" || 
								event.StatusMessage === "item-not-found" ||
								event.StatusMessage === "policy-violation") {
						const attachSession=localStorage.getItem('attachSession');
						const agentstate = this.props.chatState;
						if(agentstate === 'ENDED' || agentstate === 'SURVEY_SUBMITTED') {
							//do nothing
						}
						else if(attachSession){
							localStorage.clear();
							this.message("Unable to connect to chat session, re-starting chat");
							window.location.reload(false);
						} else {
							this.mounted && this.props.setAgentStatus({
								status: 'unavailable',
								show : false,
								message: 'The chat has ended unexpectedly, please refresh page and create a new chat to continue'
							});
							this.props.onChatErrored();
							localStorage.setItem('laststate',event.StatusMessage );
						}
					} 
					else {
						this.mounted && message.error("Connection to Chat server failed " + event.StatusMessage,5);
					}
					this.props.onAgentStopTyping();
					this.props.onEceError(ECE_CONNECT_ERROR);
					this.clearSession();
					clearInterval(this.intervalId);
				}			
			};

				// Agent completed the chat
			this.myEventHandlers.OnCustTerminateSuccess = (event) => {
				console.debug(
					'[ece-event], OnCustTerminateSuccess',event
				);
				// this.props.onChatCompleted();
				//TODO SHOW Page with No agents available at this time if AgentUnavaiable flag is active
				if(this.props.agentStatus.status === 'unavailable') {
					this.props.setAgentStatus({
						status: 'unavailable',
						show : false,
						message : this.props.agentStatus.message
					});
				}
				this.props.onAgentStopTyping();
				this.clearSession();
			};
			
			// Connection Resumed to ECE service 
			this.myEventHandlers.OnConnectionResumed = () => {
				console.debug(
					'[ece-event], OnConnectionResumed'
				);
				this.mounted && message.success('Connected back to Chat server',5);

			};
	
			/* Capture Agent typed message 
			* INCOMING MESSAGE
			*/
			this.myEventHandlers.OnAgentMessageReceived = (agentMessageReceivedEventArgs) => {
				var msg=agentMessageReceivedEventArgs.Message;
				if(msg.includes('<img ')){
					var isimgtxt = true;
					try {
					msg.split('<img ').forEach(function (stringimg,len,array){
						// this logic used for text followed by image.
						if(stringimg.length>0 && array.length===2 && isimgtxt){
							if(stringimg.includes('/>')){
								var processedobj=this.retriveIMGObj(stringimg);
								var sysurl = this.props.appConfig.eceurl;
								var fullurl = sysurl + processedobj.image;
								this.props.onMessageReceive(processedobj.text?processedobj.text:'', undefined, fullurl,processedobj.type?processedobj.type:'image');

							} else {
									var textmsg = stringimg.replace(/<[^>]+>/g, '');
									textmsg = decode(textmsg);
									this.props.onMessageReceive(textmsg);
									var imgobj=this.retriveIMGObj(array[len+1]); 
									var sysurl1 = this.props.appConfig.eceurl;
									var fullurl1 = sysurl1 + imgobj.image;
									this.props.onMessageReceive(imgobj.text?imgobj.text:'', undefined, fullurl1,imgobj.type?imgobj.type:'image');
									isimgtxt=false;
							}
					
						} else if(stringimg.length>0 && isimgtxt){
							if(stringimg.includes('/>')){
								let processedobj1=this.retriveIMGObj(stringimg);
								const sysurl = this.props.appConfig.eceurl;
								const fullurl = sysurl + processedobj1.image;
								this.props.onMessageReceive(processedobj1.text?processedobj1.text:'', undefined, fullurl,processedobj1.type?processedobj1.type:'image');

							} else {
									let textmsg = stringimg.replace(/<[^>]+>/g, '');
									textmsg = decode(textmsg);
									this.props.onMessageReceive(textmsg);
							}
						}
					},this);
					} catch(imgexp) {
						console.error("[ece-chat] error while manuplaitng image",imgexp);
					}
				} else if(msg.includes('<a ')){
					var declnk=decode(msg);
				   this.props.onMessageReceive('', undefined, declnk, 'link');
				   this.props.onAgentStopTyping();
			   }
				 else {
					// remove rich text tags
					var textmsg = msg.replace(/<[^>]+>/g, '');
					textmsg = decode(textmsg);
					this.props.onMessageReceive(textmsg);
					this.props.onAgentStopTyping();
					// this.alertNotification(textmsg);
				}
			
				// play sound
				this.playSound();
				
			};
			/* Capture Incoming notificaiton message 
			*
			*/
			this.myEventHandlers.OnServerNotificationReceived = (servernotificaiton) => {
			console.log('[ece-event], OnServerNotificationReceived',servernotificaiton);
				
			};
			
			/* Capture Error message */
			this.myEventHandlers.OnErrorOccurred = (chatErrorOccurredEventArgs) => {
				console.log('[ece-event], OnErrorOccurred', chatErrorOccurredEventArgs);
				// this.mounted && message.error('Oops! Something went wrong');
				// this.props.onEceError(ECE_GENERIC_ERROR);
				clearInterval(this.intervalId);
			};
			/* Capture on Agent non-Avialbility */
			this.myEventHandlers.OnAgentsNotAvailable = (agentsNotAvailableEventArgs) => {
				console.log(' [ece-event], OnAgentsNotAvailable', agentsNotAvailableEventArgs);
			};
			/* Capture on Dupicate session  */
			this.myEventHandlers.OnDuplicateSession = (duplicateEventArgs) => {
				console.log(' [ece-event], OnDuplicateSession', duplicateEventArgs);
				if(duplicateEventArgs && duplicateEventArgs.StatusCode === "DUPLICATE_SESSION"){
					var refresh=this.props.appConfig.refresh;
					console.log(' [ece-event], OnDuplicateSession and refresh is ', refresh);
					if(refresh){
						const sid=localStorage.getItem("sid");
						this.props.setSid(sid);
						const rid=localStorage.getItem("rid");
						// var rid =Math.floor(Math.random() * 4294967295);
						console.log("[ece-event], OnDuplicateSession request to attach method --- ",rid,sid);
						// Attach the existing chat session.
						this.myChat.Attach(sid,rid);
						// agent is assigned, so on close show survey
						//this.setState({ agentassigned: true });
						setTimeout(() => {
							this.myChat.GetTranscript();
							this.setState({ spinning: true });
						}, 1000);
					} else{
						this.props.setAgentStatus({
						status: 'unavailable',
						show : false,
						message: 'There is an active chat session in another tab, Please close window and try again'
		
					});
					clearInterval(this.intervalId);
					return;
					}
				}
			};

			/** On Transcript  */
			this.myEventHandlers.OnTranscriptFetched = (transcriptObject) => {
				clearInterval(this.intervalId);
				this.setState({ spinning: false });
				console.log(' [ece-event], OnTranscriptFetched  ', transcriptObject);
				this.postMessage("sessionid");
				const msgs=transcriptObject.Messages;
				var agentname=transcriptObject.Assignee;
				var name=agentname?.split(' ');
				if(name && name.length>0){
					this.props.onAgentJoined(name[0]);
				}
				msgs.forEach((msg, index) => {
					var who =msg.SenderType;
					var textmsg=msg.Body;
					if(who === 'System' || who === 'Agent'){
						 // replace agent first name
							if(textmsg.includes('You are now chatting with')){
								this.setState({ agentassigned: true });
								var agenttext= textmsg.replace('You are now chatting with ','');
								var name=agenttext?.split(' ');
									if(name && name.length>0){
									// this.props.onAgentJoined(name[0]);
									this.props.onMessageReceive('You are now chatting with  '+name[0],msg.Timestamp);
									}
							} else if(textmsg.includes('You have been transferred to agent ')){
								this.setState({ agentassigned: true });
								var agenttext1= textmsg.replace('You have been transferred to agent ','');
								var name1=agenttext1?.split(' ');
									if(name1 && name1.length>0){
									// this.props.onAgentJoined(name[0]);
									this.props.onMessageReceive('You have been transferred to agent '+name1[0],msg.Timestamp);
									}
							} else if(textmsg.includes('<img ')){
								let isimgtxt = true;
								textmsg.split('<img ').forEach(function (stringimg,len,array){
									// this logic used for text followed by image.
									if(stringimg.length>0 && array.length===2 && isimgtxt){
										if(stringimg.includes('/>')){
											var processedobj=this.retriveIMGObj(stringimg);
											var sysurl = this.props.appConfig.eceurl;
											var fullurl = sysurl + processedobj.image;
											this.props.onMessageReceive(processedobj.text?processedobj.text:'', undefined, fullurl,processedobj.type?processedobj.type:'image');
			
										} else {
												var textmsg = stringimg.replace(/<[^>]+>/g, '');
												textmsg = decode(textmsg);
												this.props.onMessageReceive(textmsg);
												var imgobj=this.retriveIMGObj(array[len+1]); 
												var sysurl1 = this.props.appConfig.eceurl;
												var fullurl1 = sysurl1 + imgobj.image;
												this.props.onMessageReceive(imgobj.text?imgobj.text:'', undefined, fullurl1,imgobj.type?imgobj.type:'image');
												isimgtxt=false;
										}
								
									} else if(stringimg.length>0 && isimgtxt){
										if(stringimg.includes('/>')){
											let processedobj1=this.retriveIMGObj(stringimg);
											const sysurl = this.props.appConfig.eceurl;
											const fullurl = sysurl + processedobj1.image;
											this.props.onMessageReceive(processedobj1.text?processedobj1.text:'', undefined, fullurl,processedobj1.type?processedobj1.type:'image');
			
										} else {
												let textmsg = stringimg.replace(/<[^>]+>/g, '');
												textmsg = decode(textmsg);
												this.props.onMessageReceive(textmsg);
										}
									}
								},this);
								
							} else if(textmsg.includes('<a ')){
								var declnk=decode(textmsg);
							   // display hyperlink
							   this.props.onMessageReceive('', undefined, declnk,'link');
						   }
							else {
								 textmsg=textmsg.replace(/<[^>]+>/g, '');
								 textmsg=decode(textmsg);
								this.props.onMessageReceive(textmsg,msg.Timestamp);
							}
					}else {
						if( textmsg !== transcriptObject.Subject ){
							textmsg = textmsg.replace(/<[^>]+>/g, '');
							textmsg=decode(textmsg);
							this.props.onHandleMessageSend(textmsg,msg.Timestamp);
						}
					    	
					}
				});

			};
			/* Attach Failure */ 
			this.myEventHandlers.OnConnectionAttachedFailure =(event) =>{
				console.log("[ece-chat], OnConnectionAttachedFailure ",event);
				this.setState({ spinning: false });
				this.clearSession();
				window.location.reload(false);
				clearInterval(this.intervalId);
			}

			/* Chat complete event */
			this.myEventHandlers.OnConnectionComplete = () => {
				this.props.onChatCompleted(this.props.appConfig.survey.enable);
				this.props.onAgentStopTyping();
				this.clearSession();
			};
			this.myEventHandlers.OnNetworkDisconnect =(event) =>{
				console.log("[ece-chat], OnNetworkDisconnect ",event);
				this.mounted && message.error("Network Error Connecting to Server ");
				this.props.onEceError(ECE_CONNECT_ERROR);
				clearInterval(this.intervalId);
			}
			this.myEventHandlers.OnNetworkReconnect =(event) =>{
				console.log("[ece-chat], OnNetworkReconnect ",event);
				//NOTIFICAITION
				this.mounted && message.success("Network is back to Server ");
			}
			this.myEventHandlers.OnAgentJoined =(event) =>{
				console.log("[ece-chat], OnAgentJoined ", event);
				// const username = event.AgentName;
				// this.props.onAgentJoined(username);
				// console.log('----------clear interval-----------');
				// clearInterval(this.intervalId);
			}
		}catch (exp) {
		  console.error(
			'[ece-chat] Error in Chat Handlers ', exp,
		  );
		  return;
		}
	};



	startEce = (data) => {
		// const rEmail = randomEmail({ domain: 'fcibchat.com' });;

		// console.log('rEmail: ', rEmail);
		console.log("[ece-chat] Chat iniated  ", data);
		this.props.onChatStarted();
		// store question to local variable
		this.questiontxt = data.question;
		const customerObject = new this.myLibrary.Datatype.CustomerObject();
 
		var customerParam = new this.myLibrary.Datatype.CustomerParameter();
		customerParam.eGainParentObject = "casemgmt";
		customerParam.eGainChildObject = "individual_customer_data";
		customerParam.eGainAttribute = "full_name";
		customerParam.eGainValue = data.name;
		customerParam.eGainParamName = "full_name";
		customerParam.eGainMinLength = "1";
		customerParam.eGainMaxLength = "120";
		customerParam.eGainRequired = "0";
		customerParam.eGainFieldType = "1";
		customerParam.eGainPrimaryKey = "1";
		customerParam.eGainValidationString = "^[^<>]+$";
		customerObject.AddCustomerParameter(customerParam);
  
		customerParam = new this.myLibrary.Datatype.CustomerParameter();
		customerParam.eGainParentObject = "casemgmt";
		customerParam.eGainChildObject = "email_address_contact_point_data";
		customerParam.eGainAttribute = "email_address";
		customerParam.eGainValue = data.email;
		customerParam.eGainParamName = "email_address";
		customerParam.eGainMinLength = "1";
		customerParam.eGainMaxLength = "250";
		customerParam.eGainRequired = "0";
		customerParam.eGainFieldType = "1";
		customerParam.eGainPrimaryKey = "1";
		customerParam.eGainValidationString = "^(([^<>()[\\]\\\\.,;:\\s@\\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\\"]+)*)|(\\ \".+\\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA -Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$";
		customerObject.AddCustomerParameter(customerParam);
	   
  
		customerParam = new this.myLibrary.Datatype.CustomerParameter();
		customerParam.eGainParentObject = "casemgmt";
		customerParam.eGainChildObject = "phone_number_data";
		customerParam.eGainAttribute = "phone_number";
		customerParam.eGainValue = data.phone;
		customerParam.eGainParamName = "phone_number";
		customerParam.eGainMinLength = "1";
		customerParam.eGainMaxLength = "50";
		customerParam.eGainRequired = "0";
		customerParam.eGainFieldType = "1";
		customerParam.eGainPrimaryKey = "0";
		customerParam.eGainValidationString = "([0-9 \\-\\(\\)])*$";
		customerObject.AddCustomerParameter(customerParam);
  
		customerParam = new this.myLibrary.Datatype.CustomerParameter();
		customerParam.eGainParentObject = "casemgmt";
		customerParam.eGainChildObject = "activity_data";
		customerParam.eGainAttribute = "categories";
		customerParam.eGainValue = data.category;
		customerParam.eGainParamName = "categories";
		customerParam.eGainMinLength = "1";
		customerParam.eGainMaxLength = "50";
		customerParam.eGainRequired = "1";
		customerParam.eGainFieldType = "1";
		customerParam.eGainPrimaryKey = "0";
		customerParam.eGainValidationString = "";
		customerObject.AddCustomerParameter(customerParam);
  
		customerParam = new this.myLibrary.Datatype.CustomerParameter();
		customerParam.eGainParentObject = "casemgmt";
		customerParam.eGainChildObject = "activity_data";
		customerParam.eGainAttribute = "subject";
		customerParam.eGainValue = data.question;
		customerParam.eGainParamName = "subject";
		customerParam.eGainMinLength = "1";
		customerParam.eGainMaxLength = "800";
		customerParam.eGainRequired = "1";
		customerParam.eGainFieldType = "1";
		customerParam.eGainPrimaryKey = "0";
		customerParam.eGainValidationString = "";
		customerObject.AddCustomerParameter(customerParam);
  
		var customerName = new this.myLibrary.Datatype.CustomerParameter();
		customerName.eGainParentObject = "casemgmt";
		customerName.eGainChildObject = "activity_data";
		customerName.eGainAttribute = "c2cchattype";
		customerName.eGainValue = "UnAuth";
		customerName.eGainParamName = "c2cchattype";
		customerName.eGainMinLength = "1";
		customerName.eGainMaxLength = "50";
		customerName.eGainRequired = "0";
		customerName.eGainFieldType = "2";
		customerName.eGainPrimaryKey = "0";
		customerName.eGainValidationString = "";
		customerObject.AddCustomerParameter(customerName);
		customerObject.SetPrimaryKey(customerObject.PrimaryKeyParams.PRIMARY_KEY_EMAIL, data.email);

		/* Now call the Chat initiliaztion method with your entry point and callbacks */
		this.myChat.Initialize(this.props.appConfig.channelID, 'en', 'US', this.myEventHandlers, this.props.appConfig.folder, 'v11');
		/*Now set the customer */
		this.myLibrary.SetCustomer(customerObject);
		var sessData = data
		const strData = JSON.stringify(sessData);
		localStorage.setItem("data", strData);
		// Before start of the chat check for the agent availability.
		this.eceWebAPI(this.props.appConfig.agentAvailability, ((res) => {
			console.debug("[ece-chat] agent availability ", res);
			var data = res?.data;
			if (data?.available === false) {
				// TODO
				// show agent not avialable page
				this.props.setAgentStatus({
					status: 'unavailable',
					show: false,
					message: this.props.appConfig.noagentlogin
				});
				this.props.onChatErrored();
				localStorage.setItem('laststate','Agent is not available');
			} else {

				// TO BE REMOVED 
				const sid = localStorage.getItem("sid");
				const rid = localStorage.getItem("rid");
				console.debug("[ece-event], Chat intitate Check for exisiting request and session id --- ", rid, sid);
				if (sid && this.props.appConfig.attachinitial && this.props.appConfig.refresh && rid !=='-1') {
					// var rid =Math.floor(Math.random() * 4294967295);
					console.debug("[ece-event], Chat intitate found session id  request to attach method --- ", rid, sid);
					this.myChat.Attach(sid, rid);
					this.props.setSid(sid);
					//this.setState({ agentassigned: true });
					localStorage.setItem('attachSession', true);
					this.setState({ spinning: true });
					setTimeout(() => {
						try {
							this.myChat.GetTranscript();
						} catch(e){
							this.setState({ spinning: false });
							console.error("[ece-event], transcript catch exception --- ",e);
						}
						
					}, 1000);
				} else {
					// this.props.onHandleMessageSend(sessData.question);
					this.myChat.Start();
					// call for quue time first time
					this.checkAgentQueueTime();
					this.intervalId = setInterval(() => {
						this.checkAgentQueueTime();
					}, 60 * 1000); //check time every 1 minute
				}
			}
		}));
	}

	// check for the agent wait time 
	checkAgentQueueTime = () => {
		this.eceWebAPI(this.props.appConfig.agentStatus, ((response) =>{
			console.log("[ece-chat] liveSessionStatus  ",response);
			// TODO
			// Show this time in the chat page as estimated time 
			 var waittime=response?.data?.waitTime;
			 if(waittime && waittime > 60) {
				 var temptime= waittime / 60;
				waittime = temptime.toFixed(2) + " minutes";
			 }else {
				waittime = 1 + ' minute';
			 }

			 this.props.setAgentStatus({
				status: 'available',
				time: waittime,
				show: true
			 });
		}));
	}

	render() {
		return (
			<>
				<ThemeProvider theme={defaultTheme}>
					<FixedWrapper.Root>
					{/* <FixedWrapper.Root maximizedOnInit={isMobile && !isTablet}> */}
						<FixedWrapper.Maximized>
							<Maximized 
								{...this.props} 
								startEce={this.startEce} 
								onMessageSend={this.onMessageSend}
								postMessage={this.postMessage}
								onCustomerTypingChanged={this.onCustomerTypingChanged}
								spinning={this.state.spinning}
								agentassigned={this.state.agentassigned}
							/>
						</FixedWrapper.Maximized>
						<FixedWrapper.Minimized>
							<Minimized 
								{...this.props} 
								initChat={this.initChat} 
								refresh={this.state.refresh}
							/>
						</FixedWrapper.Minimized>
					</FixedWrapper.Root>
				</ThemeProvider>
				<audio id='sound' preload='auto' muted allow="autoplay"> 
					<source src="https://chat.cibcfcib.com/c2c/static/media/chatsound.mp3"></source>
					{/* <source src={this.props.appConfig.notifsoundurl}></source> */}
				</audio>
			</>
		);
	}
}

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const parseTimestamp = timestamp => {
	const date = new Date(timestamp)
	const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
	const mins = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
	return `${ date.getDate() } ${ months[date.getMonth()] } ${ hours }:${ mins }`;
}

const parseMessages = messages =>
	messages
		.map(message => ({
			...message,
			parsedDate: parseTimestamp(message.timestamp),
		}))
		.reduce(
			(result, current) => {
				const previous = result[result.length - 1]
				if (!previous.length || previous[previous.length - 1].authorId === current.authorId) {
					result[result.length - 1].push(current)
					return result
				}
				result.push([current])
				return result
			},
			[[]],
		)

const mapStateToProps = state => {
	return {
		events: parseMessages(getEvents(state)),
		users: getUsers(state),
		ownId: getOwnId(state),
		currentAgent: getCurrentAgent(state),
		rate: getRate(state),
		chatState: getChatState(state),
		token: getToken(state),
		agentStatus: getAgentStatus(state),
		appConfig: getConfig(state)
	}
};

const mapDispatchToProps = dispatch => ({
	setConfig: (config) => { dispatch(setConfig(config)) },
	onChatStarted: () => { dispatch(chatStarted('1111')) },
	onChatCompleted: (survey) => { 	
		if(survey){
		dispatch(chatEnded());
		dispatch(showSurvey());
		localStorage.setItem('laststate','Agent has ended the chat' );
		} else {
		dispatch(submitSurvey());
		}
	},
	onChatErrored: () => { 
		dispatch(chatEnded());
	},
	onHandleMessageSend: (data,date) => {
		dispatch(
			sendMessage({
				text: data,
				date:date?date:undefined
			}),
		)
	},
	onMessageReceive: (data,date,image,type) => {
		dispatch(
			receiveMessage({
				text: data,
				date:date?date:undefined,
				image:image?image:false,
				type:type?type:undefined
			})
		);
	},
	sendMessage: text =>
		dispatch(
			sendMessage({
				text,
			}),
		),
	rateGood: () => { dispatch(rateGood()) },
	rateBad: () => { dispatch(rateBad()) },
	onAgentJoined: (agentName) => { 
		dispatch(newUser({ name: agentName }));
		dispatch(connectAgent(agentName));
	},
	setSid: (sid) => { dispatch(setSid(sid)) },
	setActivityID :(activityid) =>{dispatch(setActivityID(activityid))},
	setToken: (token) => { dispatch(setToken(token)) },
	setUUID: (uid) => { dispatch(setUUID(uid)) },
	onAgentStartTyping: () => { dispatch(onAgentStartTyping()) },
	onAgentStopTyping: () => { dispatch(onAgentStopTyping()) },
	setAgentStatus: (status) => { dispatch(setAgentStatus(status)) },
	initiateToken: (genericId) => { dispatch(initiateToken(genericId)) },
	receiveToken: () => { dispatch(receiveToken()) },
	initiateUuid: () => { dispatch(initiateUuid()) },
	receiveUuid: (uuid) => { dispatch(receiveUuid(uuid)) },
	connectEce: () => { dispatch(connectEce()) },
	onTokenError: (type) => { dispatch(onTokenError(type)) },
	onEceError: (type) => { dispatch(onEceError(type)) },
	onUuidError: (type) => { dispatch(onUuidError(type)) },
	setDispositionEndpoint: (url) => { dispatch(setDispositionEndpoint(url)) }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);